// extracted by mini-css-extract-plugin
export var authorByLineTooltipTrigger = "bs_d1";
export var authorBylineContainer = "bs_dZ";
export var authorPrefix = "bs_d0";